import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export default function ConfirmApplyManagedRunPolicyDialog({
  open,
  loading,
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog open={open} onClose={loading ? undefined : onCancel} maxWidth="sm">
      <DialogTitle>Apply latest mission policy?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This updates the operator chat&apos;s policy snapshot from the current
          workflow definition and reschedules future checks. It does not change
          past operator actions.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={loading}>
          Apply latest policy
          {loading && <CircularProgress size={16} sx={{ ml: 1 }} />}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
